import { render, staticRenderFns } from "./AnagraficheDettaglioOperatori.vue?vue&type=template&id=f137424e&scoped=true&"
import script from "./AnagraficheDettaglioOperatori.vue?vue&type=script&lang=js&"
export * from "./AnagraficheDettaglioOperatori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f137424e",
  null
  
)

export default component.exports